"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const useMergeRefs_1 = __importDefault(require("../../hooks/useMergeRefs"));
const IconConstants_1 = require("./IconConstants");
const CustomSvgIcon_1 = __importDefault(require("./CustomSvgIcon/CustomSvgIcon"));
const FontIcon_1 = __importDefault(require("./FontIcon/FontIcon"));
const useIconProps_1 = __importDefault(require("./hooks/useIconProps"));
require("./Icon.scss");
// eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
const CLICK_NOOP = (_event) => { };
function renderIcon(Icon, props) {
    return (0, jsx_runtime_1.jsx)(Icon, Object.assign({}, props));
}
const Icon = (0, react_1.forwardRef)(({ 
/**
 * component id
 */
id, onClick = CLICK_NOOP, className, icon = "", clickable = true, iconLabel, iconType = IconConstants_1.IconType.SVG, iconSize = 16, ignoreFocusStyle = false, tabindex: externalTabIndex, ariaHidden, style, useCurrentColor = false, customColor, "data-testid": dataTestId }, ref) => {
    const overrideExternalTabIndex = externalTabIndex && +externalTabIndex;
    const { screenReaderAccessProps, onClickCallback, computedClassName, iconRef } = (0, useIconProps_1.default)({
        onClick,
        iconLabel,
        clickable,
        className,
        isDecorationOnly: ariaHidden,
        ignoreFocusStyle,
        externalTabIndex: overrideExternalTabIndex
    });
    const mergedRef = (0, useMergeRefs_1.default)({ refs: [ref, iconRef] });
    if (!icon) {
        return null;
    }
    // Replace in major version change with more accurate check
    const isFunctionType = typeof icon === "function";
    // Replace in major version change with more accurate check
    if (iconType === IconConstants_1.IconType.SVG || isFunctionType || typeof icon === "object") {
        return renderIcon(icon, Object.assign(Object.assign({ id }, screenReaderAccessProps), { ref: isFunctionType ? undefined : mergedRef, size: iconSize.toString(), onClick, className: computedClassName, style, "data-testid": dataTestId }));
    }
    if (iconType === IconConstants_1.IconType.SRC) {
        return ((0, jsx_runtime_1.jsx)(CustomSvgIcon_1.default, Object.assign({ id: id, src: icon }, screenReaderAccessProps, { className: (0, classnames_1.default)(computedClassName), onClick: onClickCallback, replaceToCurrentColor: useCurrentColor, customColor: customColor, "data-testid": dataTestId })));
    }
    return ((0, jsx_runtime_1.jsx)(FontIcon_1.default, Object.assign({ id: id }, screenReaderAccessProps, { className: (0, classnames_1.default)(computedClassName), onClick: onClickCallback, ref: mergedRef, icon: icon, "data-testid": dataTestId })));
});
Icon.type = IconConstants_1.IconType;
exports.default = Icon;
